import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2.5",
  viewBox: "0 0 64 64"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<rect width=\"44\" height=\"34\" x=\"10\" y=\"10\" rx=\"3\"></rect><path d=\"M10 20h44M20 10v44M10 50h30\"></path><rect width=\"6\" height=\"6\" x=\"24\" y=\"26\" fill=\"currentColor\" rx=\"1\"></rect><rect width=\"6\" height=\"6\" x=\"34\" y=\"26\" fill=\"currentColor\" rx=\"1\"></rect><rect width=\"6\" height=\"6\" x=\"24\" y=\"36\" fill=\"currentColor\" rx=\"1\"></rect>", 5)
  ]))]))
}
export default { render: render }